import YesNoFilter from 'components/Grid/Filter/YesNo';

const YesNoDataGridFilter = ({ onChange, filter }) => (
  <YesNoFilter onChange={onChange} value={`${filter?.value}`} />
);

export default YesNoDataGridFilter;
